import { template as _$template } from "solid-js/web";
import { setStyleProperty as _$setStyleProperty } from "solid-js/web";
import { effect as _$effect } from "solid-js/web";
import { insert as _$insert } from "solid-js/web";
import { createComponent as _$createComponent } from "solid-js/web";
import { memo as _$memo } from "solid-js/web";
var _tmpl$ = /*#__PURE__*/_$template(`<div class=palette-viewer><div class=palette-viewer__grid></div><p class=palette-viewer__info>`),
  _tmpl$2 = /*#__PURE__*/_$template(`<div class=palette-viewer__swatch>`);
import { createResource, createSignal, For, Show } from "solid-js";
import { rgbToHex } from "../color.ts";
async function loadPalette(path) {
  const response = await fetch(`/baked/${path}`);
  if (!response.ok) throw new Error(`failed to load palette ${path}: ${response.status}`);
  return await response.json();
}

/** Swatch grid for a baked palette — hover a swatch to see its index and hex value. */
export function PaletteViewer(props) {
  const [data] = createResource(() => props.entry.path, loadPalette);
  const [hovered, setHovered] = createSignal(undefined);
  const hoveredColor = () => {
    const index = hovered();
    const colors = data()?.colors;
    return index === undefined || !colors ? undefined : colors[index];
  };
  return (() => {
    var _el$ = _tmpl$(),
      _el$2 = _el$.firstChild,
      _el$3 = _el$2.nextSibling;
    _el$2.addEventListener("mouseleave", () => setHovered(undefined));
    _$insert(_el$2, _$createComponent(For, {
      get each() {
        return data()?.colors ?? [];
      },
      children: (color, index) => (() => {
        var _el$4 = _tmpl$2();
        _el$4.addEventListener("mouseenter", () => setHovered(index()));
        _$effect(_$p => _$setStyleProperty(_el$4, "background-color", rgbToHex(color)));
        return _el$4;
      })()
    }));
    _$insert(_el$3, _$createComponent(Show, {
      get when() {
        return hoveredColor();
      },
      fallback: "Hover a swatch for its index and hex value",
      children: color => ["Index ", _$memo(hovered), " — ", _$memo(() => rgbToHex(color())), " — rgb(", _$memo(() => color()[0]), ", ", _$memo(() => color()[1]), ", ", _$memo(() => color()[2]), ")"]
    }));
    return _el$;
  })();
}